import React from 'react';
// import Layout from 'layout';

import { authenticationService } from 'auth/authenticationService'

import Layout from 'layout';

import DateAdapter from '@mui/lab/AdapterDateFns';
// import { Link } from 'react-router-dom';
import {
  Box, Paper,
  Typography,
  Grid, IconButton, Button,
  // TextField,
  CircularProgress,
  Alert, Select, MenuItem, FormControl, InputLabel
  // Stack
} from '@mui/material';

import {
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  BarChart, Bar, Text, LineChart, Line
} from 'recharts';


import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import TimePicker from '@mui/lab/TimePicker';
// import DateTimePicker from '@mui/lab/DateTimePicker';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

// import {
//         DesktopDatePicker,
//         AdapterDateFns,
//         LocalizationProvider
//         } from '@mui/lab';

import SearchIcon from '@mui/icons-material/Search';


function encodeQueryData(data) {
  const ret = [];
  for (let d in data)
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  return ret.join('&');
}
const CustomXAxisTick = ({ x, y, payload }: any) => {
  if (payload && payload.value) {
    return (
      <Text
        fontSize={"12px"}
        width={"12px"}
        x={x}
        y={y}
        textAnchor="middle"
        verticalAnchor="start"
      >{payload.value}</Text>
    );
  }
  return null;
};

class Estadisticas extends React.Component {
  // This syntax ensures `this` is bound within handleClick.
  // Warning: this is *experimental* syntax.
  constructor(props) {
    super(props);


    this.state = {
      search_loading: false,
      my_company_status: {
      },
      data: {
      },
      filters: {
        agno_consulta: null,
        agno_proceso: null,
        mes_consulta: 0
      },
      years: [],
    };
    this.handleLoad = this.handleLoad.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  handleLoad() {
    this.setState({ search_loading: true }, () => {
      var params = this.state.filters
      var query = encodeQueryData(params);

      authenticationService.fetchApi({
        url: '/api/estadisticas/',
        method: 'POST',
        body: JSON.stringify(params)
      })
        .then(result => {
          this.setState({ data: result, search_loading: false }, () => {
            // console.log(this.state.data)
          });
        }).catch(err => { });

    })

  }

  componentDidMount() {
    var current_year = new Date().getFullYear();
    var how_many = current_year - 2022

    let years = []
    for (let i = 2022; i <= current_year; i++) {
      years.push(i)
    }
    this.setState({
      years: years
    }, () => {

      this.setState({
        filters:
        {
          agno_proceso: current_year,
          agno_consulta: current_year,
        }
      }, () => {
        //this.handleLoad()
      })

    })


  }

  handleInputChange(event) {
  }

  handleSubmit(event) {
  }

  handleEditForm(event) {
  }
  // handleDateFilter(name, date = null) {
  //   const { filters } = { ...this.state };
  //   const currentState = filters

  //   currentState[name] = date;
  //   this.setState({ filters: currentState }, () => this.handleLoad());
  // }
  handleFilterChange(event) {
    const { filters } = { ...this.state };
    const { name, value, checked } = event.target

    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [name]: value
      }
    }));
  }

  render() {
    return (
      <Layout>
        <Paper>

          <Box p={1} m={1}>
            <Typography variant='h4'>
              Estadísticas de tickets
            </Typography>
          </Box>

          <Box p={1} m={1}>
            {/* <Grid container spacing={1}>
              <Grid item sm={6} xs={6}>
                {this.state.years.length > 0 &&
                  <FormControl fullWidth={true}
                    variant="standard"
                  >
                    <InputLabel id="tipo_label">Año del proceso</InputLabel>
                    <Select labelId="tipo_label"
                      id="agno_proceso"
                      name="agno_proceso"
                      value={this.state.filters.agno_proceso ? this.state.filters.agno_proceso : ''}
                      onChange={this.handleFilterChange}
                    >
                      {this.state.years.map((object) => {
                        return (
                          <MenuItem key={object} value={object}>{object}</MenuItem>
                        )
                      })}
                    </Select>

                  </FormControl>
                }
              </Grid>
              <Grid item sm={6} xs={6}>
                {this.state.years.length > 0 &&
                  <FormControl fullWidth={true}
                    variant="standard"
                  >
                    <InputLabel id="tipo_label">Agno de los resultados</InputLabel>
                    <Select labelId="tipo_label"
                      id="agno_consulta"
                      name="agno_consulta"
                      value={this.state.filters.agno_consulta ? this.state.filters.agno_consulta : ''}
                      onChange={this.handleFilterChange}
                    >
                      {this.state.years.map((object) => {
                        return (
                          <MenuItem key={object} value={object}>{object}</MenuItem>
                        )
                      })}
                    </Select>

                  </FormControl>
                }
              </Grid>
            </Grid> */}
            <Grid container spacing={1}>
              {/* Selector 1: Año de Proceso */}
              <Grid item sm={4} xs={12}>
                {this.state.years.length > 0 &&
                  <FormControl fullWidth={true} variant="standard">
                    <InputLabel id="proceso_label">Año del proceso</InputLabel>
                    <Select labelId="proceso_label"
                      id="agno_proceso"
                      name="agno_proceso"
                      value={this.state.filters.agno_proceso ? this.state.filters.agno_proceso : ''}
                      onChange={this.handleFilterChange}
                    >
                      {this.state.years.map((object) => {
                        return (
                          <MenuItem key={object} value={object}>{object}</MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                }
              </Grid>

              {/* Selector 2: Año de Consulta */}
              <Grid item sm={4} xs={12}>
                {this.state.years.length > 0 &&
                  <FormControl fullWidth={true} variant="standard">
                    <InputLabel id="consulta_label">Año de los resultados</InputLabel>
                    <Select labelId="consulta_label"
                      id="agno_consulta"
                      name="agno_consulta"
                      value={this.state.filters.agno_consulta ? this.state.filters.agno_consulta : ''}
                      onChange={this.handleFilterChange}
                    >
                      {this.state.years.map((object) => {
                        return (
                          <MenuItem key={object} value={object}>{object}</MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                }
              </Grid>

              {/* Selector 3: Mes de Consulta (NUEVO) */}
              <Grid item sm={4} xs={12}>
                <FormControl fullWidth={true} variant="standard">
                  <InputLabel id="mes_label">Mes de resultados</InputLabel>
                  <Select labelId="mes_label"
                    id="mes_consulta"
                    name="mes_consulta"
                    value={this.state.filters.mes_consulta !== undefined ? this.state.filters.mes_consulta : 0}
                    onChange={this.handleFilterChange}
                  >
                    <MenuItem value={0}>Todo el año</MenuItem>
                    <MenuItem value={1}>Enero</MenuItem>
                    <MenuItem value={2}>Febrero</MenuItem>
                    <MenuItem value={3}>Marzo</MenuItem>
                    <MenuItem value={4}>Abril</MenuItem>
                    <MenuItem value={5}>Mayo</MenuItem>
                    <MenuItem value={6}>Junio</MenuItem>
                    <MenuItem value={7}>Julio</MenuItem>
                    <MenuItem value={8}>Agosto</MenuItem>
                    <MenuItem value={9}>Septiembre</MenuItem>
                    <MenuItem value={10}>Octubre</MenuItem>
                    <MenuItem value={11}>Noviembre</MenuItem>
                    <MenuItem value={12}>Diciembre</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box p={1} m={1}>
            <Button variant="outlined"
              onClick={this.handleLoad}
              disabled={this.state.search_loading}
              startIcon={this.state.search_loading ? <CircularProgress size={20} /> : <SearchIcon />}
            >
              Consultar
            </Button>
          </Box>



          {this.state.data.creados &&

            <Box p={1} m={1}>


              <Box p={1} m={1}>
                <Typography variant='h5'>
                  Permisos creados por día
                </Typography>
              </Box>

              <ResponsiveContainer width='100%' aspect={9.0 / 3.0}>

                <BarChart
                  data={this.state.data.creados}
                  margin={{
                    top: 5,
                    right: 10,
                    left: 10,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="value" fill="#8884d8" />
                </BarChart>

              </ResponsiveContainer>
            </Box>
          }


          {this.state.data.creados &&

            <Box p={1} m={1}>


              <Box p={1} m={1}>
                <Typography variant='h5'>
                  Permisos pagados por día
                </Typography>
              </Box>

              <ResponsiveContainer width='100%' aspect={9.0 / 2.5}>

                <BarChart
                  data={this.state.data.pagados}
                  margin={{
                    top: 5,
                    right: 10,
                    left: 10,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="value" fill="#82ca9d" />
                </BarChart>

              </ResponsiveContainer>
            </Box>
          }

          {this.state.data.estados &&

            <Box p={1} m={1}>


              <Box p={1} m={1}>
                <Typography variant='h5'>
                  Por estados
                </Typography>
              </Box>

              <ResponsiveContainer width='100%' aspect={9.0 / 5.0}>

                <BarChart
                  data={this.state.data.estados}
                  margin={{
                    top: 5,
                    right: 10,
                    left: 10,
                    bottom: 40,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name"
                    interval={0} tick={<CustomXAxisTick />}
                  // style={{
                  //     fontSize: '0.8rem',
                  //     fontFamily: 'Roboto, sans-serif',
                  // }}
                  />
                  <YAxis />
                  <Tooltip />
                  <Legend layout="vertical" verticalAlign="top" align="right" />
                  <Bar dataKey="Traslado" stackId='a' fill="#5588FF" />
                  <Bar dataKey="Renovación" stackId='a' fill="#DD9999" />
                </BarChart>

              </ResponsiveContainer>
            </Box>
          }

          {this.state.data.total &&
            <Alert severity='info'>
              <Typography variant='overline'>
                Candidatas totales inscritas hasta hoy
              </Typography>
              <Typography variant='h1'>
                {this.state.data.total}
              </Typography>
            </Alert>
          }
          {/* --- INICIO NUEVO GRÁFICO --- */}
          {this.state.data.creados_detalle &&

            <Box p={1} m={1}>

              <Box p={1} m={1}>
                <Typography variant='h5'>
                  Detalle de tickets creados por día (Total / Traslado / Renovación)
                </Typography>
              </Box>

              <ResponsiveContainer width='100%' aspect={9.0 / 3.0}>
                <LineChart
                  data={this.state.data.creados_detalle}
                  margin={{
                    top: 5,
                    right: 10,
                    left: 10,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="Total" stroke="#8884d8" activeDot={{ r: 8 }} strokeWidth={2} />
                  <Line type="monotone" dataKey="Traslado" stroke="#7bc100" strokeWidth={2} />
                  <Line type="monotone" dataKey="Renovación" stroke="#ff8800" strokeWidth={2} />
                </LineChart>

              </ResponsiveContainer>
            </Box>
          }
          {/* --- FIN NUEVO GRÁFICO --- */}
          {/* --- INICIO GRÁFICO ESTADOS CONSOLIDADOS (BARRAS APILADAS) --- */}
          {this.state.data.estados_diarios &&

            <Box p={1} m={1}>

              <Box p={1} m={1}>
                <Typography variant='h5'>
                  Distribución por estado de tickets creados al día
                </Typography>
              </Box>

              <ResponsiveContainer width='100%' aspect={9.0 / 3.0}>
                <BarChart
                  data={this.state.data.estados_diarios}
                  margin={{
                    top: 5,
                    right: 10,
                    left: 10,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  {/* Al poner stackId="a" a todas, Recharts las apila en una sola barra por día */}
                  <Bar dataKey="SECCIONES POR VALIDAR" stackId="a" fill="#8884d8" />
                  <Bar dataKey="LISTO PARA PAGO" stackId="a" fill="#82ca9d" />
                  <Bar dataKey="SECCIONES RECHAZADAS" stackId="a" fill="#ffc658" />
                  <Bar dataKey="SECCIONES INCOMPLETAS" stackId="a" fill="#ff7300" />
                  <Bar dataKey="PAGADO" stackId="a" fill="#387908" />
                  <Bar dataKey="DESCARTADO" stackId="a" fill="#e01255" />
                  <Bar dataKey="PAGADO 1ª CUOTA" stackId="a" fill="#b5a400" />
                </BarChart>

              </ResponsiveContainer>
            </Box>
          }
          {/* --- FIN GRÁFICO ESTADOS CONSOLIDADOS --- */}
        </Paper>
      </Layout>
    );
  }
}

export default Estadisticas;
